// Mencegah nilai input type="number" berubah sendiri saat mouse wheel di-scroll
// di atas field yang sedang fokus. Field di-blur supaya browser tidak
// menambah/mengurangi angka, dan halaman tetap bisa di-scroll normal.
export default defineNuxtPlugin(() => {
  document.addEventListener(
    'wheel',
    (e: WheelEvent) => {
      const el = document.activeElement
      if (el instanceof HTMLInputElement && el.type === 'number' && e.target === el) {
        el.blur()
      }
    },
    { passive: true },
  )
})
